var a = {
  color: {
    value: "{colors.font.primary.value}"
  },
  lineHeight: {
    value: 1
  },
  fontWeight: {
    value: "{fontWeights.semibold.value}"
  },
  fontSize: {
    value: "{fontSizes.small.value}"
  },
  textAlign: {
    value: "center"
  },
  paddingVertical: {
    value: "{space.xs.value}"
  },
  paddingHorizontal: {
    value: "{space.small.value}"
  },
  backgroundColor: {
    value: "{colors.background.tertiary.value}"
  },
  borderRadius: {
    value: "{radii.xl.value}"
  },
  info: {
    color: {
      value: "{colors.font.info.value}"
    },
    backgroundColor: {
      value: "{colors.background.info.value}"
    }
  },
  warning: {
    color: {
      value: "{colors.font.warning.value}"
    },
    backgroundColor: {
      value: "{colors.background.warning.value}"
    }
  },
  success: {
    color: {
      value: "{colors.font.success.value}"
    },
    backgroundColor: {
      value: "{colors.background.success.value}"
    }
  },
  error: {
    color: {
      value: "{colors.font.error.value}"
    },
    backgroundColor: {
      value: "{colors.background.error.value}"
    }
  },
  small: {
    fontSize: {
      value: "{fontSizes.xs.value}"
    },
    paddingVertical: {
      value: "{space.xxs.value}"
    },
    paddingHorizontal: {
      value: "{space.xs.value}"
    }
  },
  large: {
    fontSize: {
      value: "{fontSizes.medium.value}"
    },
    paddingVertical: {
      value: "{space.small.value}"
    },
    paddingHorizontal: {
      value: "{space.medium.value}"
    }
  }
};
export { a as badge };